import React, { useEffect, useState } from 'react'
import Close from './../assets/images/close_icon.svg'
import { useTranslation } from 'react-i18next';
import InputFields from '../components/InputFields';
import { useAddGrocery, useUpdateGrocery } from '../hooks/hooks';
import { showSuccessToast } from '../components/common';


function AddGroceriesModal({ isOpen, onClose, isEdit, isEditItem }) {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState({
        name: "",
        unitType: "",
        stockQuantity: "",
        stockUnit: "",
        stockThreshold: "",
        stockThresholdUnit: ""
    });

    const [Error, setError] = useState({
        name: "",
        unitType: "",
        stockQuantity: "",
        stockUnit: "",
        stockThreshold: "",
        stockThresholdUnit: "",
        all: "",
    });

    const [isLoading, setIsLoading] = useState(false);
    // const unitTypeList = ['KGS', 'Gram', 'Liter', 'ML', 'Pieces'];
    const unitTypeList = [
        { key: 'KGS', name: 'કિગ્રા (KGS)' },
        { key: 'Gram', name: 'ગ્રામ (Gram)' },
        { key: 'Liter', name: 'લિટર (Liter)' },
        { key: 'ML', name: 'મિલીલીટર (ML)' },
        { key: 'Pieces', name: 'નંગ (Pieces)' },
        { key: 'Per_Person', name: 'માણસો દીઠ (Per Person)' },
        { key: 'box', name: 'બોક્સ (Box)'}
    ];

    const { mutate: addgrocery } = useAddGrocery();
    const { mutate: updategrocery } = useUpdateGrocery();

    useEffect(() => {
        if (isEdit && isEditItem) {
            setInputValue({
                name: isEditItem.name || "",
                unitType: isEditItem.unitType || '',
                stockThreshold : isEditItem.stockThreshold || '',
                stockThresholdUnit : isEditItem.stockThresholdUnit || ''
            });
        }
    }, [isEdit, isEditItem]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputValue({
            ...inputValue,
            [name]: value.toString(),
        });
        setError({
            ...Error,
            name: "",
            image: "",
            unitType: "",
            stockQuantity: "",
            stockUnit: "",
            stockThreshold: "",
            stockThresholdUnit: "",
            all: "",
        });
    };

    const onSubmit = () => {
        if (inputValue.name.toString().trim() === "") {
            setError({ ...Error, name: t('Groceries_Name_Er') });
            return;
        }

        // if (inputValue.stockThreshold.toString().trim() === "") {
        //     setError({ ...Error, stockThreshold: "Please enter minimum stock" });
        //     return;
        // }

        // if (inputValue.stockThresholdUnit.toString().trim() === "") {
        //     setError({ ...Error, stockThresholdUnit: "Please select Minimum Stock Unit" });
        //     return;
        // }

        if (inputValue.unitType.toString().trim() === "") {
            setError({ ...Error, unitType: t('Unit_Err') });
            return;
        }

        let formData = new FormData();
        formData.append("name", inputValue.name);
        formData.append("unitType", inputValue.unitType);
        formData.append("stockThreshold", inputValue.stockThreshold);
        formData.append("stockThresholdUnit", inputValue.stockThresholdUnit);

        setIsLoading(true);
        if (isEdit) {
            formData.append("id", isEditItem._id);
            updategrocery(formData, {
                onSuccess: (res) => {
                    showSuccessToast(res?.data?.message);
                    onClose(true);
                    setIsLoading(false);
                    setInputValue({ ...inputValue, name: "", unitType: "" });
                    setError({
                        ...Error,
                        name: "",
                        image: "",
                        unitType: "",
                        stockQuantity: "",
                        stockUnit: "",
                        stockThreshold: "",
                        stockThresholdUnit: "",
                        all: "",
                    });
                },
                onError: (err) => {
                    setIsLoading(false);
                    // showErrorToast(err.response.data.error);
                    setError({ ...Error, all: err.response.data.error });
                },
            });
        } else {
            addgrocery(formData, {
                onSuccess: (res) => {
                    showSuccessToast(res?.data?.message);
                    onClose(true);
                    setIsLoading(false);
                    setInputValue({ ...inputValue, name: "", unitType: "" });

                    setError({
                        ...Error,
                        name: "",
                        image: "",
                        unitType: "",
                        stockQuantity: "",
                        stockUnit: "",
                        stockThreshold: "",
                        stockThresholdUnit: "",
                        all: "",
                    });
                },
                onError: (err) => {
                    setIsLoading(false);
                    setError({ ...Error, all: err.response.data.error });
                },
            });
        }
    }


    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 bg-black backdrop-blur-sm bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full m-h-[90vh] flex flex-col">
                        {/* Fixed Header */}
                        <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-4 rounded-t-2xl flex-shrink-0">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-3">
                                    <div className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
                                        <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-semibold text-white">
                                            {isEdit ? t('update_groceries') : t('add_new_groceries')}
                                        </h3>
                                        <p className="text-orange-100 text-sm">
                                            {isEdit ? t('update_grocery_info') : t('add_new_grocery_info')}
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={() => {
                                        setInputValue({
                                            ...inputValue, name: "",
                                            image: "",
                                            unitType: "",
                                            stockQuantity: "",
                                            stockUnit: "",
                                            stockThreshold: ""
                                        });
                                        setError({
                                            ...Error,
                                            name: "",
                                            image: "",
                                            unitType: "",
                                            stockQuantity: "",
                                            stockUnit: "",
                                            stockThreshold: "",
                                            all: "",
                                        });
                                        onClose(false);
                                    }}
                                    className="p-2 bg-white bg-opacity-20 rounded-lg hover:bg-opacity-30 transition-all duration-200"
                                >
                                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        {/* Scrollable Content */}
                        <div className="flex-1 overflow-y-auto p-6">
                            <div className="space-y-6">
                                {/* Groceries Name */}
                                <div>
                                    <label className="text-sm font-medium text-gray-700 mb-2 block">
                                        {t('groceries_name')}
                                    </label>
                                    <InputFields
                                        name="name"
                                        label="groceries name"
                                        type="text"
                                        placeholder={t('pls_groceries_name')}
                                        isHideLabel="false"
                                        isFixedLabel="true"
                                        disabled={isLoading}
                                        handleChange={(e) => handleChange(e)}
                                        value={inputValue?.name}
                                        className="w-full px-4 py-3 text-gray-900 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-200 hover:bg-gray-50"
                                    />
                                    {Error?.name && <div className="text-red-500 text-sm mt-1">{Error?.name}</div>}
                                </div>

                                  {/* Unit Type */}
                                <div>
                                    <label className="text-sm font-medium text-gray-700 mb-2 block">
                                        {t('unitType')}
                                    </label>
                                    <div className="relative">
                                        <select
                                            name="unitType"
                                            value={inputValue.unitType}
                                            onChange={handleChange}
                                            placeholder="Select option"
                                            className="w-full px-4 py-3 text-gray-900 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-200 hover:bg-gray-50 appearance-none cursor-pointer pr-10"
                                        >
                                            <option value="" disabled selected>
                                                {t('select_options')}
                                            </option>
                                            {unitTypeList &&
                                                unitTypeList.map((unit) => (
                                                    <option key={unit.key} value={unit.key}>
                                                        {unit.name}
                                                    </option>
                                                ))}
                                        </select>
                                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                            </svg>
                                        </div>
                                    </div>
                                    {Error?.unitType && <div className="text-red-500 text-sm mt-1">{Error?.unitType}</div>}
                                </div>

                                {/* Stock Threshold Section */}
                                <div>
                                    <label className="text-sm font-medium text-gray-700 mb-3 block">
                                        Stock Threshold
                                    </label>
                                    <div className="grid grid-cols-3 gap-4">
                                        {/* Stock Threshold Value */}
                                        <div className="col-span-1">
                                            <label className="text-xs font-medium text-gray-600 mb-1 block">
                                                {t('stockThreshold')}
                                            </label>
                                            <InputFields
                                                name="stockThreshold"
                                                label="stockThreshold"
                                                type="text"
                                                placeholder={t('stockThreshold')}
                                                isHideLabel="false"
                                                isFixedLabel="true"
                                                disabled={isLoading}
                                                handleChange={(e) => handleChange(e)}
                                                value={inputValue?.stockThreshold}
                                                className="w-full px-3 py-2 text-gray-900 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-200 hover:bg-gray-50 text-sm"
                                            />
                                            {Error?.stockThreshold && <div className="text-red-500 text-xs mt-1">{Error?.stockThreshold}</div>}
                                        </div>

                                        {/* Stock Threshold Unit */}
                                        <div className="col-span-2">
                                            <label className="text-xs font-medium text-gray-600 mb-1 block">
                                                {t('stockThresholdUnit')}
                                            </label>
                                            <div className="relative">
                                                <select
                                                    name="stockThresholdUnit"
                                                    value={inputValue.stockThresholdUnit}
                                                    onChange={handleChange}
                                                    placeholder="Select option"
                                                    className="w-full px-3 py-2 text-gray-900 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-200 hover:bg-gray-50 appearance-none cursor-pointer pr-8 text-sm"
                                                >
                                                    <option value="" disabled selected>
                                                        {t('select_options')}
                                                    </option>
                                                    {unitTypeList &&
                                                        unitTypeList.map((unit) => (
                                                            <option key={unit.key} value={unit.key}>
                                                                {unit.name}
                                                            </option>
                                                        ))}
                                                </select>
                                                <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                                    <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                    </svg>
                                                </div>
                                            </div>
                                            {Error?.stockThresholdUnit && <div className="text-red-500 text-xs mt-1">{Error?.stockThresholdUnit}</div>}
                                        </div>
                                    </div>
                                </div>

                              

                                {/* Error Message */}
                                {Error?.all && (
                                    <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                                        <div className="flex items-center">
                                            <svg className="w-5 h-5 text-red-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                            <span className="text-red-700 text-sm">{Error?.all}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Fixed Footer */}
                        <div className="border-t border-gray-200 px-6 py-4 flex-shrink-0">
                            <div className="flex gap-3 justify-end">
                                <button
                                    onClick={() => {
                                        setInputValue({
                                            ...inputValue, name: "",
                                            image: "",
                                            unitType: "",
                                            stockQuantity: "",
                                            stockUnit: "",
                                            stockThreshold: ""
                                        });
                                        setError({
                                            ...Error,
                                            name: "",
                                            image: "",
                                            unitType: "",
                                            stockQuantity: "",
                                            stockUnit: "",
                                            stockThreshold: "",
                                            all: "",
                                        });
                                        onClose(false);
                                    }}
                                    className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all duration-200 font-medium"
                                    disabled={isLoading}
                                >
                                    {t('btnCancel')}
                                </button>
                                <button
                                    className="px-6 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-all duration-200 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed font-medium"
                                    onClick={onSubmit}
                                    disabled={isLoading}
                                >
                                    {isLoading ? (
                                        <>
                                            <svg
                                                aria-hidden="true"
                                                role="status"
                                                className="inline w-4 h-4 mr-3 text-white animate-spin"
                                                viewBox="0 0 100 101"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                    fill="#E5E7EB"
                                                />
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="currentColor"
                                                />
                                            </svg>
                                            Processing...
                                        </>
                                    ) : (
                                        isEdit ? t('btnUpdate') : t('btnSave')
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default AddGroceriesModal